import React from 'react'

import { Icon, IconName } from '@unbounded/unbounded-components'

import assertUnreachable from '~utils/assertUnreachable'

import * as Styled from './styles'

type Props = Styled.TextBlockStyleProps

function pickIconName(props: Styled.TextBlockStyleProps) {
  switch (props.type) {
    case 'error':
      return IconName.exclamation_triangle

    case 'info':
      return IconName.circle_info

    case 'loading':
      return IconName.spinner

    default:
      return assertUnreachable(props.type)
  }
}

const TextBlock: React.FC<Props> = ({ type, variant, children }) => (
  <Styled.Container type={type} variant={variant}>
    <Styled.Icon type={type} variant={variant}>
      <Icon name={pickIconName({ type })} size="large" />
    </Styled.Icon>
    <Styled.Content>{children}</Styled.Content>
  </Styled.Container>
)

export default TextBlock
